import { render, staticRenderFns } from "./EvolucionTiempoInforme.vue?vue&type=template&id=25ff39cb&scoped=true&"
import script from "./EvolucionTiempoInforme.vue?vue&type=script&lang=js&"
export * from "./EvolucionTiempoInforme.vue?vue&type=script&lang=js&"
import style0 from "./EvolucionTiempoInforme.vue?vue&type=style&index=0&id=25ff39cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff39cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSkeletonLoader})
